import { EStructureItem } from '@progress-fe/core';
import { TREE_ROOT_ITEM_ID } from './Tree';
export const TREE_ITEMS_MOCK_1 = {
    [TREE_ROOT_ITEM_ID]: {
        index: TREE_ROOT_ITEM_ID,
        isFolder: true,
        children: ['59CB3F0C-1234-0040-0040-000000000125'],
        data: {
            entityName: 'CL-100',
            entityUuid: '59CB3F0C-1234-0040-0040-000000000125',
            entityType: EStructureItem.Element,
            entitySubType: 'CoolerElement'
        }
    },
    '59CB3F0C-1234-0040-0040-000000000125': {
        index: '59CB3F0C-1234-0040-0040-000000000125',
        isFolder: true,
        children: ['1.1', '1.2'],
        data: {
            name: 'CL-100',
            entityUuid: '59CB3F0C-1234-0040-0040-000000000125',
            entityType: EStructureItem.Element,
            entitySubType: 'CoolerElement'
        }
    },
    '1.1': {
        index: '1.1',
        isFolder: true,
        children: ['1.1.1', '1.1.2'],
        data: {
            name: 'Характеристики 1'
        }
    },
    '1.1.1': {
        index: '1.1.1',
        isFolder: false,
        children: [],
        data: {
            name: 'Перепад давления',
            description: 'Входная температура',
            units: 'кПа',
            value: '150',
            path: 'path_1.1.1'
        }
    },
    '1.1.2': {
        index: '1.1.2',
        isFolder: false,
        children: [],
        data: {
            name: 'Температура',
            units: '°C',
            value: '100',
            path: 'path_1.1.2'
        }
    },
    '1.2': {
        index: '1.2',
        isFolder: true,
        children: ['1.2.1', '1.2.2'],
        data: {
            name: 'Характеристики 2'
        }
    },
    '1.2.1': {
        index: '1.2.1',
        isFolder: false,
        children: [],
        data: {
            name: 'Перепад давления',
            units: 'кПа',
            value: '250',
            path: 'path_1.2.1'
        }
    },
    '1.2.2': {
        index: '1.2.2',
        isFolder: false,
        children: [],
        data: {
            name: 'Температура',
            units: '°C',
            value: '200',
            path: 'path_1.2.2'
        }
    }
};
export const TREE_ITEMS_MOCK_2 = {
    [TREE_ROOT_ITEM_ID]: {
        index: TREE_ROOT_ITEM_ID,
        isFolder: true,
        children: ['69CB3F0C-1234-0040-0040-000000000126'],
        data: {
            entityName: 'A-100',
            entityUuid: '69CB3F0C-1234-0040-0040-000000000126',
            entityType: EStructureItem.LogicalElement,
            entitySubType: 'optimization'
        }
    },
    '69CB3F0C-1234-0040-0040-000000000126': {
        index: '69CB3F0C-1234-0040-0040-000000000126',
        isFolder: true,
        children: ['1.1', '1.2'],
        data: {
            name: 'A-100',
            entityUuid: '69CB3F0C-1234-0040-0040-000000000126',
            entityType: EStructureItem.LogicalElement,
            entitySubType: 'optimization'
        }
    },
    '1.1': {
        index: '1.1',
        isFolder: true,
        children: ['1.1.1'],
        data: {
            name: 'Оптимизируемые параметры'
        }
    },
    '1.1.1': {
        index: '1.1.1',
        isFolder: true,
        children: ['1.1.1.1', '1.1.1.2'],
        data: {
            name: 'Теплотворная способность тов. газа'
        }
    },
    '1.1.1.1': {
        index: '1.1.1.1',
        isFolder: false,
        children: [],
        data: {
            name: 'Целевое значение',
            units: 'МДж/кг',
            value: '50',
            path: 'path_1.1.1.1'
        }
    },
    '1.1.1.2': {
        index: '1.1.1.2',
        isFolder: false,
        children: [],
        data: {
            name: 'Текущее значение',
            units: 'МДж/кг',
            value: '150',
            path: 'path_1.1.1.2'
        }
    },
    '1.2': {
        index: '1.2',
        isFolder: true,
        children: ['1.2.1'],
        data: {
            name: 'Варьируемые параметры'
        }
    },
    '1.2.1': {
        index: '1.2.1',
        isFolder: true,
        children: ['1.2.1.1', '1.2.1.2'],
        data: {
            name: 'Температура на сепараторе'
        }
    },
    '1.2.1.1': {
        index: '1.2.1.1',
        isFolder: false,
        children: [],
        data: {
            name: 'Целевое значение',
            units: 'МДж/кг',
            value: '50',
            path: 'path_1.2.1.1'
        }
    },
    '1.2.1.2': {
        index: '1.2.1.2',
        isFolder: false,
        children: [],
        data: {
            name: 'Текущее значение',
            units: 'МДж/кг',
            value: '150',
            path: 'path_1.2.1.2'
        }
    }
};
//# sourceMappingURL=Tree.mocks.js.map